<template>
    <div>
        <div class="lg:hidden w-full flex flex-col lg:flex-row justify-between py-4 border-b border-gray-300">
            {{ $t('invoices') }}
        </div>
        <div class="my-8 lg:my-0">
            <Loading :loading="loading" :preserveHeight="true">
                <div class="hidden lg:flex flex-col gap-4 lg:flex-row w-full py-4 border-b border-gray-300">
                    <div class="w-full lg:w-3/12">
                        <p>
                            {{ $t('invoice_number') }}
                        </p>
                    </div>
                    <div class="w-full lg:w-3/12">
                        <p>
                            {{ $t('invoice_positions') }}
                        </p>
                    </div>
                    <div class="w-full lg:w-3/12">
                        <p>
                            {{ $t('invoice_date') }}
                        </p>
                    </div>
                    <div class="w-full lg:w-2/12">
                        <p>
                            {{ $t('user_payment_method') }}
                        </p>
                    </div>
                    <div class="w-full lg:w-3/12 text-right">
                        <p>
                            {{ $t('plain_actions') }}
                        </p>
                    </div>
                </div>

                <div v-if="get?.data?.length">
                    <div v-for="invoice in get.data" :key="invoice.id" class="flex flex-col lg:flex-row gap-4 w-full py-2 border-b border-gray-300">
                        <div class="w-full lg:w-3/12">
                            <strong>
                                {{ invoice.number }}
                            </strong>
                        </div>
                        <div class="w-full lg:w-3/12">
                            <strong class="block mb-2 lg:hidden"> {{ $t('invoice_positions') }}: </strong>
                            <p class="line-clamp-1 text-hover" ref="text_hover">
                                {{ positions(invoice.invoicePositions.data) }}
                            </p>
                        </div>
                        <div class="w-full lg:w-3/12">
                            <strong class="block mb-2 lg:hidden"> {{ $t('invoice_date') }}: </strong>
                            <p>
                                {{ formatDateByRegion($moment(invoice.invoiced_at)) }}
                            </p>
                        </div>
                        <div class="w-full lg:w-2/12">
                            <strong class="block mb-2 lg:hidden"> {{ $t('user_payment_method') }}: </strong>
                            <p>
                                {{ invoice.userPaymentMethod }}
                            </p>
                        </div>
                        <div class="w-full lg:w-3/12 text-right">
                            <div class="flex flex-row justify-start lg:justify-end items-center gap-2">
                                <FormButton class="m-0 w-auto" styling="primary p-2" @click="downloadInvoice(invoice)" :value="$t('download')"> </FormButton>
                                <FormButton class="m-0 w-auto" styling="primary p-2" @click="previewInvoice(invoice)" :value="$t('plain_view')"> </FormButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="py-2" v-else>
                    {{ $t('no_data') }}
                </div>
            </Loading>
            <Pagination :limit="3" :data="get" @pagination-change-page="paginate" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { formatDateByRegion } from '../../helpers.js';

export default {
    mounted() {
        this.loading = true;
        this.indexInvoices().then(() => {
            this.loading = false;
        });
    },

    methods: {
        formatDateByRegion,
        paginate(page = 1) {
            this.loading = true;
            this.indexInvoices({
                page: page
            }).then(() => {
                this.loading = false;
            });
        },
        async indexInvoices(params) {
            let config = {
                params: {
                    'sort[by]': 'invoiced_at',
                    'sort[order]': 'desc'
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('invoices/index', config);
        },
        downloadInvoice(invoice) {
            window.open(`/invoices/${invoice.id}/download`, '_blank');
        },
        previewInvoice(invoice) {
            window.open(`/invoices/${invoice.id}/preview`, '_blank');
        },
        positions(invoicePositions) {
            let positions = [];
            invoicePositions.forEach((invoicePosition) => {
                positions.push(invoicePosition.title);
            });
            return positions.join(', ');
        }
    },

    data: () => ({
        loading: false
    }),

    computed: {
        ...mapGetters('invoices', ['get'])
    }
};
</script>
